enum FunnelChartColors {
  Impressions = '#2E1F25',
  Reach = '#642F35',
  TotalSales = '#B1443B',
  MatchedSales = '#FFA64D',
  ExtrapolatedConversions = '#FFD700',
}

export default FunnelChartColors;
